import React, { useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import _ from 'lodash';
import NumberFormat from "react-number-format";
import { useToasts } from "react-toast-notifications";
import { COLOR_APP, COLOR_APP_CANCEL } from "../../../constants";
import { CREATE_ORDER_FROM_POST_COMMENT_HOTFIX } from "../../../graphql/order/mutation";
import { useMutation } from "@apollo/client";
function CreateOrderModal({ updateLiveStock, updateOrder, fetchPostStocks, getLiveOrders, fetchLiveOrders, liveId, showCreateOrderModal, setShowCreateOrderModal, selectedComment, postStocks, setPostStocks, setLiveComments, liveComments, getOrderData, liveSreenType }) {
    const [selectedStock, setSelectedStock] = useState({});
    const [amount, setAmount] = useState(0);
    const [notify, setNotify] = useState({
        show: false,
        msg: "",
        color: ""
    });

    const { addToast } = useToasts();

    // const [createOrder, { loading: createLoading }] = useMutation(CREATE_ORDER_FROM_POST_COMMENT);
    const [createOrder, { loading: createLoading }] = useMutation(CREATE_ORDER_FROM_POST_COMMENT_HOTFIX);

    const onSelectStock = async (e) => {
        const checkStock = postStocks.filter(stock => e?.target?.value.trim().split("ລະຫັດ: ")[0] !== "" ? stock.cfMessage === e?.target?.value.trim().split("ລະຫັດ: ")[0] : stock.cfMessage === e?.target?.value.trim().split("ລະຫັດ: ")[1])

        if (checkStock.length > 0) {
            setSelectedStock(checkStock[0]);
            setAmount(1)
        }
    }

    const _createOrder = async () => {
        try {

            if (createLoading) return;
            if (_.isEmpty(selectedStock)) {
                setNotify({
                    show: true,
                    msg: "ເລືອກສິນຄ້າໃດຫນຶ່ງກ່ອນ!",
                    color: "orange"
                })
                return;
            }
            if (amount <= 0) {
                setNotify({
                    show: true,
                    msg: "ຈໍານວນສິນຄ້າຕ້ອງຫລາຍກວ່າ 1",
                    color: "orange"
                })
                return;
            }
            const SHOP_ID = await localStorage.getItem("SHOP");

            let _newOrder = {
                type: liveSreenType ? liveSreenType : "POST",
                post: liveId,
                live: liveId,
                postStock: selectedStock?.id,
                liveStock: selectedStock?.id,
                stock: selectedStock?.stock?.id,
                amount: parseInt(amount) ?? 1,
                productName: selectedStock?.stock?.name ?? "",
                currency: selectedStock?.stock?.currency ?? "ກີບ",
                cfMessage: selectedStock?.cfMessage ?? "",
                fbMessage: selectedComment?.message,
                commentId: selectedComment?.commentId,
                price: parseInt(selectedStock?.stock?.price) ?? 0,
                originPrice: parseInt(selectedStock?.stock?.originPrice) ?? 0,
                totalPrice: parseInt(selectedStock?.stock?.price * amount) ?? 0,
                cfName: selectedComment?.name,
                shop: SHOP_ID,
                userFbId: selectedComment?.psid,
                pageAccessToken: selectedComment?.pageAccessToken,
                page: selectedComment?.pageId
            }
            let _res = await createOrder({
                variables: {
                    data: _newOrder,
                },
            });
            console.log("order res: ", _res )
            // if (!_.isEmpty(_res?.data?.createOrderFromPostComment?.id)) {
            if (!_.isEmpty(_res?.data?.createOrderFromPostCommentHotfix?.id)) {
                setShowCreateOrderModal(false);

                getOrderData({
                    variables: {
                        where: {
                            post: liveId,
                            isDeleted: false
                        },
                        skip: 0,
                        limit: 1000
                    }
                });

                // update post stocks
                const _updatePostStocks = postStocks.map((_postStock) => {
                    if (_postStock?.id === selectedStock?.id) return { ..._postStock, amount: parseInt(_postStock?.amount) - parseInt(amount) ?? 1 }

                    return _postStock
                })
                setPostStocks(_updatePostStocks);

                // update post comments
                const _updatePostComments = liveComments?.map((_comment) => {
                    if (_comment?.id === selectedComment?.id) return { ..._comment, isCreated: true }

                    return _comment
                })
                setLiveComments(_updatePostComments)

                setShowCreateOrderModal(false);
                _clearData();
                setNotify({
                    show: true,
                    msg: "ສ້າງອໍເດີ້ສໍາເລັດ!",
                    color: "green"
                })

            } else {
                setShowCreateOrderModal(false);
                _clearData();
                setNotify({
                    show: true,
                    msg: "ສ້າງອໍເດີ້ບໍ່ສໍາເລັດ!",
                    color: "danger"
                })
            }
            return;
        } catch (error) {
            console.log("_createOrder Error: ", error);
            if(error?.message === "SHOP_SETTING_NOT_FOUND"){
                setNotify({
                    show: true,
                    msg: "ກະລຸນາກວດສອບການຕັ້ງຮ້ານ!",
                    color: "danger"
                })
                return;
            } else if (error?.message === "ORDER_ALREADY_EXISTS"){
                setNotify({
                    show: true,
                    msg: "ສຳລັບລູກຄ້າຄົນນີ້ ອໍເດີ້ຖືກສ້າງສໍາເລັດ!",
                    color: "orange"
                })
                return;
            } else {
                setNotify({
                    show: true,
                    msg: "ເກີດຂໍ້ຜີດພາດທີ່ບໍ່ຄາດຄີດ!",
                    color: "danger"
                })
                return;
            }
        }
    }

    const _clearData = () => {
        setAmount(0)
        setSelectedStock()
    }

    return (
        <>
            <Modal show={showCreateOrderModal} onHide={() => {
                if (createLoading) return;
                setShowCreateOrderModal(false)
            }}>
                <Modal.Body>
                    <h3 style={{ fontWeight: 'bold', alignSelf: 'center' }}>ສ້າງອໍເດີ້</h3>
                    <Form.Group>
                        <div>ຊື່ລູກຄ້າ</div>
                        <Form.Control value={selectedComment?.name} />
                    </Form.Group>
                    <div style={{ display: 'flex', margin: '10px 4px' }}>
                        <Form.Group style={{ marginRight: 20 }}>
                            <div style={{ textAlign: "start" }}>ລະຫັດ CF</div>
                            <div className="input-group">
                                <input
                                    type="text"
                                    list="listItem"
                                    placeholder="ເລືອກສິນຄ້າ"
                                    onChange={(e) => onSelectStock(e)}
                                    className="form-control form-control-md"
                                />
                                <datalist id="listItem">
                                    {postStocks?.length > 0 && postStocks?.map((lStock, index) => {
                                        if (lStock?.amount <= 0 || !lStock?.isPublished) return "";
                                        return (
                                            <option key={index} value={"ລະຫັດ: " + lStock?.cfMessage}>
                                                {"ສິນຄ້າ: " + lStock?.stock?.name}, {"ຈຳນວນ: " + lStock?.amount},{"ລາຄາ: " + lStock?.stock?.price}
                                            </option>
                                        );
                                    })}
                                </datalist>
                            </div>
                        </Form.Group>
                        <Form.Group>
                            <div>ຊື່ສິນຄ້າ</div>
                            <Form.Control readOnly placeholder="ຊື່ສິນຄ້າ..." value={selectedStock?.stock?.name ?? ''} />
                        </Form.Group>
                    </div>
                    <div style={{ display: 'flex', margin: '10px 4px' }}>
                        <Form.Group style={{ marginRight: 20 }}>
                            <div>ຈໍານວນ ({selectedStock?.amount})</div>
                            <NumberFormat
                                name="amount"
                                className="form-control"
                                onChange={(e) => {
                                    if (e.target.value > selectedStock?.amount) {
                                        addToast("ປ້ອນຈໍານວນທີ່ນ້ອຍກວ່າ: " + selectedStock?.amount, {
                                            appearance: "error",
                                            autoDismiss: true,
                                        });
                                        return;
                                    }
                                    setAmount(e.target.value)
                                }
                                }
                                value={amount ?? 1}
                                placeholder="ຈໍານວນ"
                                thousandSeparator={true}
                                prefix={""}
                            />
                        </Form.Group>
                        <Form.Group>
                            <div>ລາຄາ</div>
                            <Form.Control readOnly value={selectedStock?.stock?.price} />
                        </Form.Group>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'end' }}>
                        <Button
                            onClick={() => {
                                if (createLoading) return;
                                _clearData();
                                setShowCreateOrderModal(false);
                            }}
                            style={{ background: 'transparent', color: COLOR_APP_CANCEL, borderColor: COLOR_APP_CANCEL }}>
                            ຍົກເລີກ
                        </Button>
                        <Button
                            onClick={() => {
                                if (createLoading) return;
                                _createOrder();
                            }}
                            style={{ background: COLOR_APP, marginLeft: 10, width: 100, border: 'none' }}>
                            {createLoading ? <Spinner
                                size="sm"
                                animation="border"
                            /> : "ບັນທືກ"}
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={notify.show} onHide={() => setNotify({ show: false, msg: "", color: "" })}>
                <Modal.Body>
                    <h6 style={{ fontWeight: 'bold', alignSelf: 'center', color: notify.color }}>{notify.msg}</h6>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CreateOrderModal;